import React from 'react';
import { Icon } from 'b3';
import ReactTooltip from 'react-tooltip';

export default function ScheduledCallIcon() {
	return (
		<div className="scheduled-icon-wrapper">
			<Icon icon="call-1" filled size={20} showTooltipFor="scheduled-icon-tooltip" />	
			<ReactTooltip id="scheduled-icon-tooltip" place='bottom' type='dark'>
				<span>Scheduled Call</span>
			</ReactTooltip>
		</div>		
	);
}


// WEBPACK FOOTER //
// ./app/components/schedule-wizard/ScheduledCallIcon.js